const STEPS = [
  { n: "01", title: "Request Your Free Quote", body: "Fill out our 60-second form or call 833-309-LIFE. No obligation, no pressure." },
  { n: "02", title: "Speak With A Licensed Agent", body: "Our specialists compare top-rated carriers to find the lowest rate for your age, health, and budget." },
  { n: "03", title: "Lock In Your Coverage", body: "Sign your policy electronically. Your family is protected the moment your first premium clears." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 lg:py-28 bg-[#0B203B] text-white" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-[#E8C97A] font-semibold">How It Works</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight mt-3">
            Three Simple Steps To Lasting Protection.
          </h2>
          <div className="accent-line mt-5" />
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-8 lg:gap-12">
          {STEPS.map((s, idx) => (
            <div
              key={s.n}
              data-testid={`step-${s.n}`}
              className="relative pl-8 md:pl-0"
            >
              <div className="hidden md:block absolute top-3 left-0 right-0 h-px bg-[#C5A059]/30" />
              <span className="font-serif text-[#C5A059] text-6xl leading-none">{s.n}</span>
              <h3 className="font-serif text-2xl mt-4">{s.title}</h3>
              <p className="text-white/75 mt-3 leading-relaxed">{s.body}</p>
              {idx === 2 && (
                <a
                  href="#quote-form"
                  data-testid="how-cta-final"
                  className="inline-flex items-center justify-center h-11 px-6 rounded-md mt-6 bg-[#C5A059] text-[#0B203B] font-semibold hover:bg-[#D4AF37] transition-colors"
                >
                  Start Now
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
